import { METODOS } from '../actions/types';

const initialState = {
    listado: []
};

export default function metodosReducer(state = initialState, action) {
    switch (action.type) {
        case METODOS.BUSCAR:
            return { ...state, listado: action.payload };

        default:
            return state;
    }
}
